export default {
  init() {
    // JavaScript to be fired on the home page
    var usedListing = jQuery('.used-listing');

    jQuery('.used-listing__layout').on('click', '> button', function() {
      jQuery(this).addClass('active').siblings().removeClass('active');

      if ( jQuery(this).hasClass('used__listView') ) {
        if ( !jQuery(usedListing).hasClass('list-view') ) {
          jQuery(usedListing).toggleClass('list-view grid-view');
        }
      } else {
        if ( !jQuery(usedListing).hasClass('grid-view') ) {
          jQuery(usedListing).toggleClass('grid-view list-view');
        }
      }
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/taxUsedCat.js